import { z } from 'zod';
import { baseEmailDTOSchema } from './base-email-dto';

export const trialEmailSchemas = [
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('welcome_trial'),
    data: z.object({
      name: z.string().min(1),
      organizationDisplayName: z.string().min(1),
    }),
  }),
] as const;
